import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The type ramp (src/styles/app.css @theme) lives in the `text-` namespace.
// tailwind-merge cannot infer that text-meta/text-body/… are font sizes, so
// without this registration it treats them as text colors and silently drops
// them whenever a real color utility follows in the same cn() call.
const RAMP_FONT_SIZES = [
  "micro",
  "kicker",
  "caption",
  "meta",
  "body",
  "title-sm",
  "title",
  "title-lg",
  "display-sm",
  "display",
  "display-lg",
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [...RAMP_FONT_SIZES] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
